export default { 
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILED:'LOGIN_FAILED',
  LOGOUT_SUCCESS : 'LOGOUT_SUCCESS',
  CLOSE_ERROR: 'CLOSE_ERROR',
}